import { CardData } from "./types";
import { FRAME_NAMES } from "../../constants";

export const isValid = (cardData: Partial<CardData>) =>
  !Object.keys(FRAME_NAMES).some(
    (fieldName: keyof typeof FRAME_NAMES) => cardData[fieldName] === undefined
  );
